module.exports = __webpack_public_path__ + "/static/assets/cbce5aef3c3b611073790b49bc49bc26.gif";